import axios from "axios";

export default {
    joinPendingLogin: async (name, email, invitationHash) => {
        const { data } = await axios.post('/join_hash_login', {}, {
            params: {
                n: name,
                e: email,
                ih: invitationHash
            }
        })
        return data
    }
}